import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
  Button,
  TextField,
  MuiThemeProvider,
  createMuiTheme
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { deleteUser, getUserById, postUser, updateUser } from '../../../../api/user'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'

// Create theme for delete button (red)
const theme = createMuiTheme({
  palette: {
    secondary: {
      main: '#F64E60'
    }
  }
})

function getEmptyAdmin() {
  return {
    fullName: '',
    email: '',
    role: 'admin',
    password: '',
    repeatPassword: ''
  }
}

export default function EditAdminsPage() {
  const [admin, setAdmin] = useState(getEmptyAdmin())
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const adminId = useParams().id
  const history = useHistory()

  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

  useEffect(() => {
    if (!adminId) {
      disableLoadingData()
      return
    }
    getUserById(adminId).then(res => {
      if (res.status === 200) {
        const user = res.data
        delete user.password
        setAdmin(user)
        disableLoadingData()
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'No se ha podido obtener el administrador.' })
      history.push('/admins')
    })
  }, [adminId, disableLoadingData, history])

  function saveAdmin() {
    if (!admin.password || !admin.repeatPassword) {
      alertError({ error: null, customMessage: 'Por favor, ingrese una contraseña.' })
      return
    }
    if (admin.password !== admin.repeatPassword) {
      alertError({ error: null, customMessage: 'Las contraseñas no coinciden.' })
      return
    }
    delete admin.repeatPassword
    if (!adminId) {
      postUser(admin).then(res => {
        if (res.status === 201) {
          alertSuccess({ title: '¡Guardado!', customMessage: 'Administrador creado con éxito.' })
          history.push('/admins')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'No se ha podido guardar el administrador.' })
      })
    } else {
      updateUser(adminId, admin).then(res => {
        if (res.status === 200) {
          alertSuccess({ title: '¡Guardado!', customMessage: 'Cambios guardados con éxito.' })
          history.push('/admins')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'No se han podido guardar los cambios.' })
      })
    }
  }

  const handleChange = (element) => (event) => {
    setAdmin({ ...admin, [element]: event.target.value })
  }

  if (isLoadingData)
    return <ContentSkeleton />
  else return (
    <>
      <Card>
        <CardHeader title='Editar administrador'>
        </CardHeader>
        <CardBody>
          <TextField
            id={`fullName`}
            label="Nombre completo"
            value={admin.fullName}
            onChange={handleChange('fullName')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            id={`email`}
            label="Correo electrónico"
            value={admin.email}
            onChange={handleChange('email')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            id={`password`}
            label="Contraseña"
            value={admin.password}
            onChange={handleChange('password')}
            InputLabelProps={{
              shrink: true
            }}
            type="password"
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            id={`repeatPassword`}
            label="Repetir contraseña"
            value={admin.repeatPassword}
            onChange={handleChange('repeatPassword')}
            InputLabelProps={{
              shrink: true
            }}
            type="password"
            margin="normal"
            variant="outlined"
            required
          />
        </CardBody>
      </Card>
      <Button
        onClick={() => history.push('/admins')}
        variant="outlined"
        style={{ marginRight: '20px' }}>
        Atrás
      </Button>
      <Button
        onClick={() => saveAdmin()}
        variant="outlined"
        color="primary"
        style={{ marginRight: '20px' }}>
        Guardar
      </Button>
      {adminId && <>
        <MuiThemeProvider theme={theme}>
          <Button
            onClick={() => setOpenConfirmDialog(true)}
            variant="outlined"
            color="secondary">
            Eliminar
          </Button>
        </MuiThemeProvider>

        <ConfirmDialog
          title={'¿Está seguro de que quiere eliminar este administrador?'}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteUser(adminId).then(res => {
              if (res.status === 204 || res.status === 200) {
                alertSuccess({ title: '¡Eliminado!', customMessage: 'Administrador eliminado con éxito.' })
                history.push('/admins')
              }
            }).catch(error => {
              alertError({ error: error, customMessage: 'No se ha podido eliminar el administrador.' })
            })
          }}
        />
      </>}
    </>
  );
}
